import React from 'react'

const AboutUs = () => {
  return (
    <div style={{marginTop:"80px"}}>AboutUs</div>
  )
}

export default AboutUs